(function() {
  'use strict';

  angular.module('eclipseApp.core').directive('internetPackageInfo', function() {
    return {
      restrict: 'E',
      scope: {
        package: '=package',
        delegate: '=delegate',
        inout: '=inout',
        mixins: '=mixins'
      },
      replace: true,
      templateUrl: 'modules/checkout/views/internet-package-info-directive.html',
      link: function($scope) {
        console.log('@internetPackageInfo@internetPackageInfo ', $scope);
      }
    };
  });
})();
